// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  collection as _collection,
  collectionCount as _collectionCount,
  collectionCountSnap as _collectionCountSnap,
  collectionData as _collectionData,
  doc as _doc,
  docData as _docData,
  fromRef as _fromRef,
  snapToData as _snapToData
} from 'rxfire/firestore/lite';

export const collectionSnapshots = ɵzoneWrap(_collection, true);
export const collectionCount = ɵzoneWrap(_collectionCount, true);
export const collectionCountSnap = ɵzoneWrap(_collectionCountSnap, true);
export const collectionData = ɵzoneWrap(_collectionData, true);
export const docSnapshots = ɵzoneWrap(_doc, true);
export const docData = ɵzoneWrap(_docData, true);
export const fromRef = ɵzoneWrap(_fromRef, true);
export const snapToData = ɵzoneWrap(_snapToData, true);
